import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatDate, refId, refLabel } from '../../lib/format';
import { useEntityList, SectionHead, statoLista, BoolPill, OpenLink } from './common';

/**
 * Regolamenti di utilizzo delle sale.
 *
 * Ogni sala ha il suo regolamento. Quando ne esiste uno attivo il condomino
 * se lo vede in fase di prenotazione e puo' accettarlo: la versione accettata
 * resta scritta sulla prenotazione.
 */
export default function Regolamenti() {
    const { items, loading, error, reload } = useEntityList('regolamento', 'data_pubblicazione', 'desc');

    const stato = statoLista({
        loading: loading,
        error: error,
        empty: items.length === 0,
        icon: 'file-lines',
        message: 'Nessun regolamento pubblicato.',
        onRetry: reload
    });

    return (
        <section className="lv-card lv-card-pad">
            <SectionHead
                eyebrow="Regole di utilizzo"
                title="Regolamenti"
                subtitle="Ogni sala ha il suo: un solo regolamento attivo per sala alla volta."
                action={
                    <Link to="/admin/regolamenti/nuovo" className="lv-btn lv-btn-primary lv-btn-pill">
                        <FontAwesomeIcon icon={['fas', 'plus']} />
                        Nuovo regolamento
                    </Link>
                }
            />

            {stato || (
                <div className="lv-table-wrap">
                    <table className="lv-table">
                        <thead>
                            <tr>
                                <th>Regolamento</th>
                                <th>Sala</th>
                                <th>Pubblicato</th>
                                <th>Stato</th>
                                <th>Azioni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map(r => (
                                <tr key={r.id}>
                                    <td data-label="Regolamento">
                                        <div className="lv-cell-strong">{r.titolo}</div>
                                        <div className="lv-cell-sub">versione {r.versione}</div>
                                    </td>
                                    <td data-label="Sala">
                                        {refId(r.idSala)
                                            ? refLabel(r.idSala, ['nome'])
                                            : <span className="lv-cell-sub">Sala non indicata</span>}
                                    </td>
                                    <td data-label="Pubblicato">{formatDate(r.data_pubblicazione)}</td>
                                    <td data-label="Stato">
                                        <BoolPill value={r.attivo} labelOn="Attivo" labelOff="Archiviato" />
                                    </td>
                                    <td data-label="Azioni">
                                        <div className="lv-row-actions">
                                            <OpenLink to={`/admin/regolamenti/${r.id}`} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
}
